import {
  ToolkitFeatureFlag,
  PopoverProvider,
  Popover,
  PopoverTrigger,
  SecondaryButton,
  TabProvider,
  TabList,
  Tab,
  TabPanel,
} from '@cko/primitives';
import React, { useState } from 'react';
import { ErrorBoundary } from '@cko/dashboard-shared';
import styled from 'styled-components';
import { useDeveloperToolsProvider } from '../../context';
import { OverrideKeys } from '../../types';
import { useDeveloperToolsEnabled } from '../../useDeveloperToolsEnabled';
import { DeveloperToolsIcon } from '../DeveloperToolsIcon';
import { OverlayToolbar } from './OverlayToolbar';
import {
  FeatureFlagsPanel,
  MfeEntriesPanel,
  PermissionsPanel,
  UserPreferencesPanel,
} from './Panels';

const PopoverTriggerContainer = styled.div`
  position: fixed;
  top: 15px;
  right: 50%;
  z-index: var(--z-order-floating-element);
`;

const StyledPopover = styled(Popover)`
  min-height: 50%;
  min-width: 50%;
  z-index: 99999;
`;

export const OverlayPanel = () => {
  const isDeveloperToolsEnabled = useDeveloperToolsEnabled();
  const { selectedTab, setSelectedTab, overrides } = useDeveloperToolsProvider();
  const [open, setOpen] = useState<boolean>(false);

  const setTab = (tab: string) => {
    if (Object.keys(overrides).includes(tab)) {
      setSelectedTab(tab as OverrideKeys);
    }
  };

  const close = () => setOpen(!open);

  if (!isDeveloperToolsEnabled) {
    return null;
  }

  return (
    <ToolkitFeatureFlag flag="v11">
      <PopoverProvider open={open} onOpenChange={close}>
        <PopoverTriggerContainer>
          <PopoverTrigger>
            <SecondaryButton onClick={close}>
              <DeveloperToolsIcon />
            </SecondaryButton>
          </PopoverTrigger>
        </PopoverTriggerContainer>
        <StyledPopover defaultDirection="bottom">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 auto',
              alignItems: 'stretch',
              justifyContent: 'stretch',
              gap: 'var(--layout-soybean)',
              width: '50vw',
              height: '75vh',
            }}
          >
            <ErrorBoundary>
              <div style={{ flex: '1 1 auto', width: '100%', height: '100%' }}>
                <TabProvider currentValue={selectedTab} onChange={setTab}>
                  <TabList aria-label="dev tools tab list">
                    <Tab size="sm" value="permissions">
                      Permissions
                    </Tab>
                    <Tab size="sm" value="featureFlags">
                      Feature Flags
                    </Tab>
                    <Tab size="sm" value="mfeEntries">
                      MFE Entries
                    </Tab>
                    <Tab size="sm" value="userPreferences">
                      User Preferences
                    </Tab>
                  </TabList>
                  <TabPanel value="permissions">
                    <PermissionsPanel />
                  </TabPanel>
                  <TabPanel value="featureFlags">
                    <FeatureFlagsPanel />
                  </TabPanel>
                  <TabPanel value="mfeEntries">
                    <MfeEntriesPanel />
                  </TabPanel>
                  <TabPanel value="userPreferences">
                    <UserPreferencesPanel />
                  </TabPanel>
                </TabProvider>
              </div>
            </ErrorBoundary>
            <OverlayToolbar />
          </div>
        </StyledPopover>
      </PopoverProvider>
    </ToolkitFeatureFlag>
  );
};
